<template>
    <div>
        <div v-if="initializing" class="d-flex justify-content-center">
            <Loading />
        </div>
        <div v-else>
            <div class="d-flex justify-content-between align-items-center" style="flex-wrap: wrap;">
                <el-input
                    v-model="filter.name"
                    @input="runFilter"
                    placeholder="Registrant Name (lastname, firstname)"
                    class="col-12 col-sm m-0 p-0 mr-3"
                    style="min-width: 250px;"
                />
                <el-input
                    v-model="filter.regNoOrId"
                    @input="runFilter"
                    placeholder="Registration"
                    class="col-12 col-sm m-0 p-0 mr-3"
                    style="min-width: 250px;"
                />
                <el-button @click="getData" class="btn-primary">Refresh</el-button>
            </div>
            <template v-if="fieldDatas.length">
                <div class="border p-4 mt-4" v-for="f in fieldDatas" :key="f._id" style="background: #fff; position: relative;">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center" style="gap:20px; flex-wrap: wrap; ">
                            <div>
                                <label style="color: gray; padding-top:10px;" for="">Name : </label>
                                {{ f.registration | registrationName }}
                            </div>
                            <div>
                                <label style="color: gray; padding-top:10px;" for="">Registration ID: </label>
                                {{ f.registration._id }}
                            </div>
                            <div>
                                <label style="color: gray; padding-top:10px;" for="">Registration Number: </label>
                                {{ f.registration.confirmationNumber }}
                            </div>
                        </div>
                        <div class="d-flex">
                            <el-tooltip content="Delete" placement="top">
                                <el-button @click="remove(f._id)" size="mini" class="d-flex justify-content-center align-items-center btn-danger" style="border-radius: 999px; height: 30px; width: 30px;">
                                    <fa style="height: 10px; width: 10px;"  :icon="['fas', 'trash']" />
                                </el-button>
                            </el-tooltip>
                            <el-tooltip :content="modes[f.registration._id] == 'edit' ? 'View' : 'Edit'" placement="top-start">
                                <el-button @click="toggleMode(f.registration._id)" size="mini" class="d-flex justify-content-center align-items-center" style="border-radius: 999px; height: 30px; width: 30px;">
                                    <fa v-if="modes[f.registration._id] == 'edit' "  :icon="['fas', 'eye']" />
                                    <fa v-else :icon="['fas', 'pen']" />
                                </el-button>
                            </el-tooltip>
                        </div>
                    </div>
                    <CheckinDataForm
                        hideEditButton
                        :mode="modes[f.registration._id]"
                        class="my-3"
                        :fields="f.fields" 
                        :registration="f.registration"
                        @change="handleCheckpointFieldDataChange"
                    />
                </div>
                <el-button :loading="loading" @click="updateFields" class="btn-primary mt-4" style="width: 100%;">Save</el-button>
            </template>
            <div v-else class="d-flex justify-content-center mt-4">
                No records
            </div>
        </div>
    </div>
</template>

<script>
import http from "../../http";
import CheckinDataForm from "../../components/CheckinDataForm.vue"
import Loading from "../Loading.vue";
import swal from "sweetalert2";

export default {
    components:{
        CheckinDataForm,
        Loading
    },
    computed:{
        getChanged(){
            let obj = {}
            this.changed.forEach(el =>{
                obj[el] = true
            })
            return obj
        },
    },
    data(){
        return {
            fieldDatas: [],
            fieldDatasBackup: [],
            recordedCheckpointFieldData: [],
            loading: true,
            initializing: true,
            filter:{
                name: null,
                regNoOrId: null
            },
            modes: {}
        }
    },
    methods:{
        toggleMode(regid){
            let backup = { ...this.modes }
            if(!backup[regid]) backup[regid] = 'edit';
            else backup[regid] = backup[regid] == 'view' ? 'edit' : 'view';
            this.modes = { ...backup }
        },
        async getData(){
            this.loading = true
            try {
                const res = await http.get(`/api/checkpointfields-data/admin?eventId=${this.$route.params.eventId}&withRegistrations=true`);
                this.fieldDatas = res.data.data;
                this.fieldDatasBackup = res.data.data;
            } catch (error) {
                this.$store.dispatch('handleErrors', error);
            }
            this.loading = false
        },
        runFilter(){
            this.fieldDatas = this.fieldDatasBackup.filter(f => {
                if(this.filter.name){
                    let name = this.getNameFromRegistration(f.registration);
                    let names = this.filter.name.split(',')
                    names.forEach((el, i) => {
                        names[i] = el.trim()
                    });
                    let fullName = names.join(",")
                    if(name.toUpperCase().indexOf(fullName.toUpperCase()) != -1) return true; 
                }
                if(this.filter.regNoOrId){
                    return f.registration.confirmationNumber == this.filter.regNoOrId || f.registration._id == this.filter.regNoOrId
                }
                if(!this.filter.name && !this.filter.regNoOrId) return true;
                return false;
            })
        },
        handleCheckpointFieldDataChange(output){
            this.removeCheckpointFieldData(output.registration);
            this.recordedCheckpointFieldData.push(output);
            this.needsSavingFields = true
        },
        removeCheckpointFieldData(regId){
            this.recordedCheckpointFieldData = this.recordedCheckpointFieldData.filter(data => data.registration != regId);
        },
        async updateFields(){
            this.loading = true
            try {
                const res = await http.post(`/api/checkpointfields-data/update-fields`, {
                    eventId: this.$route.params.eventId,
                    checkpointFieldData: this.recordedCheckpointFieldData
                })
                this.$notify(res.data.message);
            } catch (error) {
                this.$store.dispatch('handleErrors', error);
            }
            this.loading = false
        },
        getNameFromRegistration(registration){
            let name = ''
            const firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            const lastName = registration.fields.find(field => field.fieldMapping === 'lastName')

            if (lastName) name += lastName.value + ','
            if (firstName) name += firstName.value

            return name
        },

        async remove(fid){
            try {
                let { value: confirmed } = await swal({
                    title: `Are you sure you want to delete the record ?`,
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-default btn-fill'
                })

                if (!confirmed) {
                    return
                }

                const res = await http.delete(`/api/checkpointfields-data/${fid}`)
                this.$notify(res.data.message)
                this.fieldDatas = this.fieldDatas.filter(el => el._id != fid);
            } catch (error) {
                this.$store.dispatch("handleErrors", error);
            }
        }
    },
    async mounted(){
        await this.getData();
        this.initializing = false
    },

    filters: {
        registrationName: (registration) => {
            let name = ''
            const firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            const lastName = registration.fields.find(field => field.fieldMapping === 'lastName')

            if (firstName) name += firstName.value + ' '
            if (lastName) name += lastName.value

            return name
        },
        formatTimestamp: (date) => moment(date).format('DD MMM YYYY HH:mm')
    },
}


</script>

<style scoped>

.delete-btn{
    position: absolute; 
    right: 90px; 
    top:100px; 
    z-index: 100;
}

@media screen and (max-width: 1140px){
    .delete-btn{
        right: 45px; 
        top:150px; 
    }
}

@media screen and (max-width: 1130px){
    .delete-btn{
        right: 45px; 
        top:200px; 
    }
}


@media screen and (max-width: 510px){
    .delete-btn{
        right: 45px; 
        top:280px; 
    }
}


</style>